import { useQuery } from '@tanstack/react-query'
import apiClient from 'application/core/data/apiClient'

export type SbpBank = {
  name: string
  logo: string
  url: string // Example: bank100000000111://qr.nspk.ru/{QRC_ID}{QUERY_STRING}
}

export type SbpBanks = {
  platform: 'ios' | 'android' | 'desktop'
  type: 'qr'
  members: SbpBank[]
}

const fecthSbpBanks = async (platform: 'ios' | 'android' | 'desktop' = 'desktop') => {
  const { data } = await apiClient.get<SbpBanks>(`/api/sbp_banks?platform=${platform}`)

  return data
}

export const useSbpBanks = (
  {
    platform = 'desktop',
    enabled,
  }: { platform?: 'ios' | 'android' | 'desktop'; enabled: boolean } = {
    platform: 'desktop',
    enabled: true,
  },
) => {
  return useQuery<SbpBanks>(['sbpBanks'], () => fecthSbpBanks(platform), {
    cacheTime: 1000 * 60 * 60 * 24, // 24h
    enabled,
  })
}
